import React from "react";
import styled from "styled-components";
import { Colors } from "../config";
const disclaimerImg = require("../assets/images/disclaimer_icon.png");
const closeIcon = require("../assets/images/close_white.png");

const Disclaimer = ({ onClose }) => {
  return (
    <DisclaimerWrapper>
      <DisclaimerImg src={disclaimerImg} alt="error" />
      <DisclaimerText>
        Please review and update your and your dependent's document on SAP for
        seamless booking.
      </DisclaimerText>
      <DisclaimerIcon onClick={onClose} src={closeIcon} alt="error" />
    </DisclaimerWrapper>
  );
};

export default Disclaimer;

const DisclaimerWrapper = styled.div`
  background: #b6b7b94d;
  border-radius: 0.625rem;
  width: 85%;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    width: calc(100% - 3rem);
  }
`;
const DisclaimerText = styled.div`
  color: ${Colors.white};
  font-size: 0.75rem;
  font-weight: 400;
`;
const DisclaimerImg = styled.img``;
const DisclaimerIcon = styled.img`
  width: 0.75rem;
`;
